import React, {useRef} from 'react';
import useMouse from '@react-hook/mouse-position'
import {IProps} from './types';
import * as S from './styles';
import { useDragLayer } from "react-dnd";
import PreviewComponent from '@routes/private/Studio/components/PreviewComponent';

const DragDesigns:React.FC<IProps> = (props) => {
  const ref = useRef(null);
  const mouse = useMouse(ref, {
    enterDelay: 200,
    leaveDelay: 100,
  });

  const {
    itemType,
    isDragging,
    item,
    currentOffset,
  } = useDragLayer((monitor) => ({
    item: monitor.getItem(),
    itemType: monitor.getItemType(),
    currentOffset: monitor.getSourceClientOffset(),
    isDragging: monitor.isDragging(),
  }));

  const getItemStyles = (currentOffset:any) => {
    if (!currentOffset) {
      return {
        display: "none"
      };
    }
  
    const { x, y } = currentOffset;
    const transform = `translate(${x}px, ${y}px)`;

    return {
      transform,
      WebkitTransform: transform
    };
  };
  
  return (
    <S.Root ref={ref} >
      <S.DragContainer style={getItemStyles(currentOffset)}>
        {props.counter>1 &&
        <S.Counter>
            <S.Number>{props.counter}</S.Number>
        </S.Counter>}
        {item?.item ? 
          <S.Preview>
            <PreviewComponent
              index={0}
              key={0}
              item={item.item}
              showMetadata={false}
              selected={true}
              onActions={()=>{}}
            /> 
          </S.Preview>
        : ''}
      </S.DragContainer>
    </S.Root>
  );
}

export default DragDesigns;